<template>
    <div>
        <SnackbarComponent v-model="snackbar.show" :message="snackbar.message" :color="snackbar.color" />
        <v-dialog v-model="dialog" max-width="1300" persistent>
            <v-card class="blog-dialog">
                <v-card-title class="text-h5 pa-5">
                    Edit User Guidelines
                </v-card-title>
                <v-divider />
                <v-card-text class="pa-0 d-flex flex-column">
                    <v-form ref="form" class="h-100 d-flex flex-column">
                        <v-row no-gutters class="dialog-content">
                            <!-- LEFT -->
                            <v-col cols="12" md="4" class="left-panel pa-5" style="border-right:1px solid #e0e0e0;">
                                <v-text-field v-model="formData.title" label="Sub Module Name" variant="outlined"
                                    density="compact" clearable class="mb-2" />

                                <div class="text-subtitle-1 font-weight-medium mb-3">
                                    Attachments
                                </div>

                                <v-btn block color="primary" prepend-icon="mdi-paperclip" :loading="uploadingAttachment"
                                    @click="$refs.attachmentInput.click()">
                                    Upload Image / Video
                                </v-btn>

                                <v-btn v-if="formData.attachments.length" block color="error" variant="outlined"
                                    prepend-icon="mdi-delete-sweep" class="mt-2" @click="removeAllAttachments">
                                    Remove All Attachments
                                </v-btn>

                                <input ref="attachmentInput" type="file" class="d-none" accept="image/*,video/*"
                                    multiple @change="onAttachmentSelected" />

                                <v-row class="mt-4" dense>
                                    <v-col cols="12" v-for="(path, index) in formData.attachments" :key="index">
                                        <v-card variant="outlined" class="pa-2 d-flex align-center">
                                            <v-avatar rounded size="60">
                                                <v-icon v-if="isImage(path)" color="primary" size="36">
                                                    mdi-image
                                                </v-icon>

                                                <v-icon v-else-if="isVideo(path)" color="red" size="36">
                                                    mdi-video
                                                </v-icon>

                                                <v-icon v-else size="36">
                                                    mdi-file
                                                </v-icon>
                                            </v-avatar>

                                            <div class="ml-3 flex-grow-1">
                                                <div class="font-weight-medium">
                                                    {{ getFileName(path) }}
                                                </div>

                                                <div class="text-caption">
                                                    {{ getFileType(path) }}
                                                </div>
                                            </div>

                                            <v-btn
                                                icon
                                                color="primary"
                                                variant="text"
                                                :loading="downloadingAttachmentIndex === index"
                                                @click="downloadAttachment(path, index)"
                                            >
                                                <v-icon>mdi-download</v-icon>
                                            </v-btn>

                                            <v-btn icon color="error" variant="text" @click="removeAttachment(index)">
                                                <v-icon>mdi-delete</v-icon>
                                            </v-btn>

                                        </v-card>
                                    </v-col>
                                </v-row>

                            </v-col>

                            <!-- RIGHT -->
                            <v-col cols="12" md="8" class="pa-6 right-panel">
                                <div class="right-scroll">
                                    <div class="rich-text-editor">
                                        <v-card variant="outlined" class="editor-container">

                                            <div class="editor-toolbar">
                                                <v-btn icon @click="formatText('bold')">
                                                    <v-icon>mdi-format-bold</v-icon>
                                                </v-btn>

                                                <v-btn icon @click="formatText('italic')">
                                                    <v-icon>mdi-format-italic</v-icon>
                                                </v-btn>

                                                <v-btn icon @click="formatText('underline')">
                                                    <v-icon>mdi-format-underline</v-icon>
                                                </v-btn>

                                                <v-divider vertical class="mx-2" />

                                                <!-- <v-btn icon @click="$refs.imageInput.click()">
                                                    <v-icon>mdi-image-plus</v-icon>
                                                </v-btn>

                                                <v-btn icon @click="$refs.videoInput.click()">
                                                    <v-icon>mdi-video-plus</v-icon>
                                                </v-btn> -->
                                            </div>
                                            <v-divider />

                                            <div ref="editorContent" class="editor-content" contenteditable="true"
                                                @input="handleEditorInput" @keyup="updateToolbarState"
                                                @mouseup="updateToolbarState" @click="updateToolbarState"></div>

                                        </v-card>
                                    </div>
                                </div>

                            </v-col>

                        </v-row>
                    </v-form>
                </v-card-text>

                <v-divider />

                <v-card-actions class="pa-4">
                    <v-spacer />

                    <v-btn variant="text" @click="handleClose" color="grey">
                        Cancel
                    </v-btn>

                    <v-btn color="primary" variant="flat" :loading="loading" @click="handleSubmit">
                        Update User Guide
                    </v-btn>

                </v-card-actions>

            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { generateClient } from "aws-amplify/api";
import { edit_user_guide_topic } from "@/graphql/mutations";
import SnackbarComponent from "@/components/Extras/Snackbar.vue";
import S3AmplifyMixin from "@/mixins/S3Amplify";
const client = generateClient();


export default {
    name: "CreateNestUserGuideDialog",
    components: {
        SnackbarComponent,
    },
    props: {
        modelValue: Boolean,

        UserGuideCreate: {
            type: Object,
            default: () => ({})
        },

        selectedSubGuide: {
            type: Object,
            default: () => ({})
        }
    },
    mixins: [S3AmplifyMixin],
    emits: ["update:modelValue", "created"],
    data() {
        return {
            uploadingAttachment: false,
            downloadingAttachmentIndex: null,
            loading: false,
            formData: {
                title: "",
                guide_description: "",
                attachments: [],
            },
            activeFormats: {
                bold: false,
                italic: false,
                underline: false,
            },
            snackbar: {
                show: false,
                message: "",
                color: "success",
            },

        };
    },
    computed: {
        dialog: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);
            },
        },
    },
    watch: {
        async modelValue(val) {
            if (!val) return;

            this.resetForm();

            this.formData.title =
                this.selectedSubGuide.title;

            // Load attachments directly from API response
            this.formData.attachments =
                JSON.parse(
                    JSON.stringify(
                        this.selectedSubGuide.sub_module_attachments || []
                    )
                );

            // Load guide content from S3
            if (this.selectedSubGuide.sub_module_content_s3_path) {
                try {
                    const content = await this.getFileFromS3(
                        this.selectedSubGuide.sub_module_content_s3_path,
                        "bms"
                    );

                    const json = JSON.parse(content);

                    this.formData.guide_description =
                        json.guide_description || "";

                    this.$nextTick(() => {
                        if (this.$refs.editorContent) {
                            this.$refs.editorContent.innerHTML =
                                this.formData.guide_description;
                        }
                    });
                } catch (error) {
                    console.error("Failed to load guide content", error);
                }
            }
        }
    },
    methods: {
        async downloadAttachment(path, index) {
            this.downloadingAttachmentIndex = index;

            try {
                await this.downloadFileFromS3(
                    path,
                    this.getFileName(path),
                    "bms"
                );

                this.snackbar = {
                    show: true,
                    message: "Attachment downloaded successfully.",
                    color: "success",
                };
            } catch (error) {
                console.error(error);

                this.snackbar = {
                    show: true,
                    message: "Failed to download attachment.",
                    color: "error",
                };
            } finally {
                this.downloadingAttachmentIndex = null;
            }
        },
        async removeAttachment(index) {
            try {
                const path = this.formData.attachments[index];

                await this.deleteFile(path, "bms");

                this.formData.attachments.splice(index, 1);

                this.snackbar = {
                    show: true,
                    message: "Attachment removed successfully.",
                    color: "success",
                };
            } catch (error) {
                console.error(error);

                this.snackbar = {
                    show: true,
                    message: "Failed to remove attachment.",
                    color: "error",
                };
            }
        },

        async removeAllAttachments() {
            try {
                for (const path of this.formData.attachments) {
                    await this.deleteFile(path, "bms");
                }

                this.formData.attachments = [];

                this.snackbar = {
                    show: true,
                    message: "All attachments removed successfully.",
                    color: "success",
                };
            } catch (error) {
                console.error(error);

                this.snackbar = {
                    show: true,
                    message: "Failed to remove attachments.",
                    color: "error",
                };
            }
        },
        isImage(path) {
            return /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(path);
        },

        isVideo(path) {
            return /\.(mp4|mov|avi|mkv|webm|m4v)$/i.test(path);
        },

        getFileName(path) {
            return path.split("/").pop();
        },

        getFileType(path) {
            if (this.isImage(path)) return "IMAGE";
            if (this.isVideo(path)) return "VIDEO";
            return "FILE";
        },
        async uploadGuideContent() {
            const key = `UserGuide/${this.formData.title}/${Date.now()}/guide-content.json`;

            const payload = {
                guide_description: this.formData.guide_description,
                attachments: this.formData.attachments
            };

            const file = new File(
                [JSON.stringify(payload)],
                "guide-content.json",
                {
                    type: "application/json",
                }
            );

            return await this.uploadFile(file, key, "bms");
        },
        async onAttachmentSelected(event) {

            const files = [...event.target.files];

            if (!files.length) return;

            this.uploadingAttachment = true;

            try {

                for (const file of files) {

                    const isImage = file.type.startsWith("image/");
                    const isVideo = file.type.startsWith("video/");

                    if (!isImage && !isVideo) continue;

                    const key = `UserGuide/${this.formData.title
                        }/Attachments/${file.name}`;

                    const s3Path = await this.uploadFile(
                        file,
                        key,
                        "bms"
                    );

                    this.formData.attachments.push(s3Path);

                }

            } finally {

                this.uploadingAttachment = false;
                event.target.value = "";

            }

        },
        formatText(command) {
            this.$refs.editorContent.focus();

            document.execCommand(command, false, null);

            this.$nextTick(() => {
                this.updateToolbarState();
                this.formData.guide_description =
                    this.$refs.editorContent.innerHTML;
            });
        },

        handleEditorInput() {
            this.formData.guide_description =
                this.$refs.editorContent.innerHTML;
        },

        updateToolbarState() {
            this.$nextTick(() => {
                try {
                    this.activeFormats.bold =
                        document.queryCommandState("bold");
                    this.activeFormats.italic =
                        document.queryCommandState("italic");
                    this.activeFormats.underline =
                        document.queryCommandState("underline");
                } catch (e) { }
            });
        },
        handleClose() {
            this.dialog = false;
            this.resetForm();
        },
        resetForm() {
            this.formData = {
                title: "",
                guide_description: "",
                attachments: [],
            };

            this.$nextTick(() => {
                if (this.$refs.editorContent) {
                    this.$refs.editorContent.innerHTML = "";
                }
            });

            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        },
        async handleSubmit() {
            const { valid } = await this.$refs.form.validate();

            if (!valid) return;
            this.loading = true;

            try {
                const guideContentPath =
                    await this.uploadGuideContent();

                const modules = JSON.parse(
                    JSON.stringify(this.UserGuideCreate.guide_sub_modules || [])
                );
                const index = modules.findIndex(
                    item => item.title === this.selectedSubGuide.title
                );

                if (index !== -1) {
                    modules[index] = {
                        ...modules[index],
                        title: this.formData.title,
                        guide_content_s3_path: guideContentPath
                    };
                }

                const input = {
                    guide_topic_id: this.selectedSubGuide.guide_topic_id,
                    title: this.formData.title,
                    sub_module_content_s3_path: guideContentPath,
                    sub_module_attachments: this.formData.attachments
                };

                const response = await client.graphql({
                    query: edit_user_guide_topic,
                    variables: {
                        input: input,
                    },
                });

                const responseData = JSON.parse(response.data.edit_user_guide_topic);

                if (responseData.status === "SUCCESS") {
                    this.snackbar = {
                        show: true,
                        message: responseData.status_message || "User Guide created successfully!",
                        color: "success",
                    };
                    this.$emit("created");
                    this.handleClose();
                } else {
                    this.snackbar = {
                        show: true,
                        message: responseData.status_message || "Failed to create User Guide",
                        color: "error",
                    };
                }
            } catch (error) {
                console.error("Error creating User Guide", error);
                this.snackbar = {
                    show: true,
                    message:
                        (error.errors && error.errors[0]?.message) ||
                        error.message ||
                        "An error occurred while creating User Guide",
                    color: "error",
                };
            } finally {
                this.loading = false;
            }
        },
    },
};

</script>

<style>
.blog-dialog {
    height: 85vh;
    display: flex;
    flex-direction: column;
}

.blog-dialog .v-card-text {
    flex: 1;
    overflow-y: auto;
    padding: 0;
}

.dialog-content {
    flex: 1;
    display: flex;
    min-height: 0;
}

/* LEFT */

.left-panel {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    min-height: 0;
}

/* RIGHT */

.right-panel {
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
}

.right-scroll {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
}

.rich-text-editor {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
}

.editor-container {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

.editor-toolbar {
    flex-shrink: 0;
}

.editor-content {
    flex: 1;
    min-height: 0;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 18px;
    outline: none;
    word-break: break-word;
}
</style>